<template>
	<c-dialog ref="dialog" width="500" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">

		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
            <c-form-item label="关联客户" required >
                <c-select name="customer_id" async @search="searchCustomer" :value-data="selectedCustomer" :disabled="editState || fastAdd"></c-select>
            </c-form-item>
<!--			<c-form-item label="账号" required>-->
<!--				<c-input name="user_name" maxlength="20" :disabled="is_manage"></c-input>-->
<!--			</c-form-item>-->
			<c-form-item label="姓名" required>
				<c-input name="user_realname" maxlength="10" ></c-input>
			</c-form-item>
			<c-form-item label="手机号码" required>
				<c-input name="phone" maxlength="11"></c-input>
			</c-form-item>
			<c-form-item label="头像">
                <c-upload-file name="head_photo" type="image" media></c-upload-file>
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="27"></custom-form>
		</c-form>
		
		<!--创建/编辑部门弹窗-->
		<department-edit ref="departmentEdit"></department-edit>
	</c-dialog>
</template>

<script>
import departmentEdit from "./department_edit.vue";
import {mapState, mapGetters} from "vuex";
export default {
	components: {
		departmentEdit
	},
	
	data() {
		return {
            fastAdd:false,
			editState:false,
			user_type:1,
			selectedRole:[],
			selectedDepartment:[],
            selectPositionLevel:[],
            selectedOutlet:[],
            selectedCustomer:[],
			is_manage:false,                        //是否超级管理员（1：是，2：否）
            selectedRequireSkills:[]                //关联售后服务网点定位维度
        }
	},

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo']),
		...mapGetters(['freeEdition']),
	},

	methods: {
		/*********打开编辑框，初始化**********/
		async open(data) {
			this.editState = !!data;
			if (!this.editState && !(await this.checkDataCount('SYSTEM_USER')).data) return;
			this.is_manage = false;
			this.$refs.form.clear();
            this.$refs.customForm.init();
			if (data) {
				//查询部门详情
				this.request({
					url:'/sys_user/detail',
					data: {
						id:data.id
					},
					success:data => {
                        this.skills = data.detailInfo.skills;
						this.$refs.form.set(data.detailInfo);
                        if(data.detailInfo.customer_id){
                            this.selectedCustomer = [{
                                name:data.detailInfo.customer_name,
                                value:data.detailInfo.customer_id
                            }]
                        }
					}
				})
			}else{
				this.$refs.form.set({
					user_type: 2,
					pricing_type: 1,
				});
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑用户' : '创建用户'
			});
		},
        openForAdd(data) {
            this.user_type = 2;
            this.editState=false;
            this.fastAdd = true;
            //清空表单数据
            this.$refs.form.clear();
            this.$refs.form.set({
                user_type: this.user_type,
            });
            //处理选中的【客户信息】
            this.selectedCustomer = [{
                name: data.customer_name,
                value: data.id
            }];
            this.$refs.dialog.open({
                title: '创建客户账号'
            });
        },

        /*******搜索【客户】下拉框信息*****************/
        searchCustomer(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'CUSTOMER',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/sys_user/edit':'/sys_user/add',
				rule: {
					// user_name: '请输账号',
					user_realname: '请输姓名',
                    phone: '请输入手机号',
                    customer_id: data => {
						var flag = true;
						if(!data.customer_id){
							let msg = "请选择关联客户";
							return msg;
						}
						return flag;
					},
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
                    data.role_ids = [2];
                    data.user_type=2 ;
                    data.user_name= data.phone+ "_" + data.customer_id;
					return data;
				},
				success: (data, res) => {
					next();
					if (this.editState){//编辑
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else {//新增
						this.$confirm({
							message: res,
							buttonName: '知道了',
							cancelButton: false,
							resolve: () => {
							}
						});

					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>